import React from 'react';
import ServiceInVictoria from '../../components/ServiceInVictoria';
import ServiceDescriptionSection from '../../components/ServiceDescriptionSection';
import ServiceLegalRepresentationRationale from '../../components/ServiceLegalRepresentationRationale';
import ServiceContactUsSection from '../../components/ServiceContactUs';
import '../../assets/styles/ServicePage.css';

const BailApplication = () => {
  return (
    <div className="servicePage">
      <div className="servicePageContent">
        <div className="header">Bail Application</div>
        <div className="body">
          <ServiceDescriptionSection 
            header="What is Bail?"
            content="Bail is essentially a legal agreement between the accused and the court. If granted, it means the accused can remain free until their court date, under specific conditions set by the court. Failing to comply with these conditions can result in arrest and cancellation of bail."
          />
          <ServiceInVictoria
            header="Bail Applications in Victoria"
            content="In Victoria, bail is a legal process that allows a person charged with a criminal offence to remain in the community while awaiting their court appearance. Bail ensures the accused complies with certain conditions set by the court to prevent further offending, ensure public safety, and guarantee they attend court when required."
          />
          <ServiceDescriptionSection 
            header="When is Bail Needed?"
            content={
              <div>
                <div>
                  Bail applications are typically made if a person has been charged with a criminal offence and is held in custody. The accused can apply for bail at several stages of the legal process:
                </div>
                <ul>
                  <li>After being charged by the police</li>
                  <li>During the initial court hearing</li>
                  <li>During the trial process (if further remand is requested)</li>
                </ul>
              </div>
            }
          />
          <ServiceDescriptionSection
            header="How is Bail Decided?"
            content={
              <div>
                <div>The court considers several factors before granting or denying bail, including:</div>
                <ul>
                  <li><strong>The nature and seriousness of the offence</strong>: Serious crimes, such as violent offences, are less likely to result in bail being granted.</li>
                  <li><strong>Risk to public safety</strong>: The court assesses whether the accused poses any risk to the community, such as the likelihood of re-offending.</li>
                  <li><strong>Flight risk</strong>: The court considers whether the accused is likely to flee and not return for their court hearings.</li>
                  <li><strong>Previous criminal history</strong>: If the accused has a history of not complying with court orders, bail may be denied.</li>
                  <li><strong>Personal circumstances</strong>: The accused’s ties to the community, family responsibilities, and employment may also be considered.</li>
                </ul>
              </div>
            }
          />
          <ServiceDescriptionSection
            header="Bail Conditions"
            content={
              <div>
                <div>If bail is granted, the accused must comply with certain conditions to ensure they attend court and do not re-offend while on bail. These conditions can include:</div>
                <ul>
                  <li>Reporting regularly to a police station</li>
                  <li>Residing at a specific address</li>
                  <li>Not contacting specific individuals or witnesses</li>
                  <li>Surrendering passports to prevent international travel</li>
                  <li>Abstaining from drugs and alcohol</li>
                  <li>Complying with curfews</li>
                </ul>
              </div>
            }
          />
          <ServiceDescriptionSection
            header="Bail Refusal and Reapplication"
            content="In Victoria, if bail is refused, the accused can reapply, but there are restrictions. Reapplications can only be made if there is a significant change in circumstances, such as new evidence or if the accused has been in custody for an extended period."
          />
          <ServiceLegalRepresentationRationale
            header="Legal Representation for Bail Applications"
            content="Legal advice and representation are crucial when applying for bail, as the process can be complex. An experienced lawyer can present a strong case to the court, outlining why bail should be granted and addressing any concerns the court may have regarding risk."
          />
          <ServiceContactUsSection
            header="Contact Us for Legal Assistance"
            content="If you or someone you know needs assistance with a bail application in Victoria, contact us for expert legal advice. Our experienced team is here to guide you through the process and ensure your rights are protected."
          />
        </div>
      </div>
    </div>
  );
};

export default BailApplication;
